
import { Component, Vue, Prop } from 'vue-property-decorator';
import ProductVariantTable from './ProductVariantTable.vue';
import { FilterColumnList } from '@/collections/filter_columns';

@Component({
  components: {
    ProductVariantTable,
  },
})
export default class ReorderSettingTable extends Vue {
  @Prop({ default: false })
  public isSelectAll!: boolean;

  @Prop({ default: null })
  public supplierId!: number | null;

  @Prop({ default: null })
  public locationId!: number | null;

  @Prop({ default: () => new FilterColumnList() })
  public reportFilters!: FilterColumnList;

  @Prop({ required: true })
  public productScope!: 'product' | 'variant';

  @Prop({ required: true })
  public scopeType!: 'supplier' | 'location';

  @Prop({ default: () => [] })
  public value!: any[];

  private search = '';

  private get selectedProducts(): any[] {
    return this.value;
  }

  private set selectedProducts(val: any[]) {
    this.$emit('input', val);
  }

  // Expose the child component's fetchProducts method
  public async fetchProducts() {
    const productTableComponent = this.$refs.productTable as any;
    if (productTableComponent && typeof productTableComponent.fetchProducts === 'function') {
      await productTableComponent.fetchProducts();
    } else {
      // ProductVariantTable component or fetchProducts method not found
      this.$emit('error', 'Failed to reload product data');
    }
  }

  private handleError(message: string) {
    this.$emit('error', message);
  }

  private handleTotalItemsUpdate(totalItems: number) {
    this.$emit('update:totalItems', totalItems);
  }
}
